import type { UIEvent } from 'react';
import { useCallback } from 'react';
import Button from '../button/HighlightableButton';
import { classNameForElement, StyleElem, styleForElement } from './PopUpView.style';

export interface IPopUpViewProps {
    show?: boolean;
    title: string;
    textAccept: string;
    textDecline: string;
    onAccept?: () => void;
    onDecline?: () => void;
}

function PopUpView(props: IPopUpViewProps): JSX.Element {
    const style = (elem: StyleElem) => styleForElement(elem, props);
    const className = (elem: StyleElem) => classNameForElement(elem, props);
    const { onAccept, onDecline, title, textAccept, textDecline } = props;

    const onClickYes = useCallback(
        (event: UIEvent) => {
            event.preventDefault();
            onAccept?.();
        },
        [onAccept],
    );

    const onClickNo = useCallback(
        (event: UIEvent) => {
            event.preventDefault();
            onDecline?.();
        },
        [onDecline],
    );

    return (
        <div className={className(StyleElem.Container)} style={style(StyleElem.Container)}>
            <div
                className={className(StyleElem.AlertContainer)}
                style={style(StyleElem.AlertContainer)}
            >
                <div
                    className={className(StyleElem.AlertTitle)}
                    style={style(StyleElem.AlertTitle)}
                >
                    {title}
                </div>
                <Button
                    onClick={onClickYes}
                    className={className(StyleElem.AlertOptionYes)}
                    style={style(StyleElem.AlertOptionYes)}
                >
                    {textAccept}
                </Button>
                <Button
                    onClick={onClickNo}
                    className={className(StyleElem.AlertOptionNo)}
                    style={style(StyleElem.AlertOptionNo)}
                >
                    {textDecline}
                </Button>
            </div>
        </div>
    );
}

export default PopUpView;
